
import { Component, Vue, Watch, Emit } from "vue-property-decorator";
import Loading from "@/components/loading/Loading.vue";
import ModalGardenhotels from "@/components/modal/ModalGardenhotels/ModalGardenhotels.vue";
import store from "@/store";

@Component({
  components: {
    Loading,
    ModalGardenhotels,
  },
})
export default class App extends Vue {
  private defaultLayout: string = "default";
  private loadingTimer: any = null;
  private showLoading: boolean = true;
  get layout(): string {
    if (this.$route.meta && this.$route.meta.layout)
      return this.$route.meta.layout;
    if (this.$route.path.startsWith("/en")) {
      return "default-en-layout";
    } else {
      return "default-layout";
    }
  }
  get loaded(): boolean {
    return store.getters.loaded;
  }
  @Watch("loaded")
  private changeLoadedState(newVal: boolean) {
    if (newVal) {
      this.clearLoadingTimer();
    } else {
      this.setLoadingTimer();
    }
  }

  @Emit()
  private setLoadingTimer() {
    this.clearLoadingTimer();
    this.loadingTimer = setTimeout(() => {
      this.showLoading = true;
    }, 600);
  }

  @Emit()
  private clearLoadingTimer() {
    this.showLoading = false;
    clearTimeout(this.loadingTimer);
  }
  private async onFocusTab() {
    if (store.getters["auth/line"]) {
      await store
        .dispatch("auth/updateUser")
        .then((data) => {
          if (!data.token) {
            this.$router.push({
              path: "/login",
              query: {
                redirect: this.$route.fullPath,
              },
            });
          }
        })
        .catch(async (e) => {
          if (e.status === 409) {
            alert(
              "別の法人アカウントでLINEログインが行われました。\n再度ログインし直してください。"
            );
            await store.dispatch("auth/logout");
            return this.$router.push({
              path: "/login",
              query: {
                redirect: this.$route.fullPath,
              },
            });
          }
        });
    }
  }

  private mounted() {
    if (this.loaded) {
      this.clearLoadingTimer();
    } else {
      this.setLoadingTimer();
    }

    // window.addEventListener("focus", this.onFocusTab);

    document.addEventListener("visibilitychange", async () => {
      if (document.visibilityState === "visible") {
        this.onFocusTab();
      }
    });

  }
}
